module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09K26D98G.67d1c63b.jpg";